/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AzurePatchManagementReportTriggerRequest {
    getFixupPrototypeFunction() { return AzurePatchManagementReportTriggerRequest.fixupPrototype; }

    static newInstance(model: Partial<AzurePatchManagementReportTriggerRequest>): AzurePatchManagementReportTriggerRequest {
        let obj = Object.assign(new AzurePatchManagementReportTriggerRequest(), model);
        AzurePatchManagementReportTriggerRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AzurePatchManagementReportTriggerRequest>): AzurePatchManagementReportTriggerRequest {
        if (!model) return null;
        return AzurePatchManagementReportTriggerRequest.newInstance(<AzurePatchManagementReportTriggerRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AzurePatchManagementReportTriggerRequest) {
        if (!obj) return;

        models.AzurePatchManagementReportTriggerRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AzurePatchManagementReportTriggerRequest): boolean {
        Object.setPrototypeOf(obj, AzurePatchManagementReportTriggerRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Provide service_account_id to trigger the azure patch report generation
     */
    service_account_id: string;

}
